import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d75eba9")

_pushScopeId("data-v-7d75eba9")
const _hoisted_1 = {
  id: "booking-v4-goods-package",
  "data-testid": "booking-v4-goods-package",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_3 = {
  key: 5,
  class: "flex items-center gap-2 mt-2 relative"
}
const _hoisted_4 = {
  for: "save-package-checkbox",
  class: "text-12px text-gray-lp-300"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_SavedPackageCards = _resolveComponent("SavedPackageCards")!
  const _component_ItemDetailsV4 = _resolveComponent("ItemDetailsV4")!
  const _component_CommoditySectionV4 = _resolveComponent("CommoditySectionV4")!
  const _component_ModalAllCommodityV4 = _resolveComponent("ModalAllCommodityV4")!
  const _component_PackageWeightSectionV4 = _resolveComponent("PackageWeightSectionV4")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: _ctx.$t('bookingV4.goods.title'),
            fontSize: 16,
            bold: "bold",
            fontColor: "text-black-lp-100"
          }, null, 8, ["label"]),
          (_ctx.showResetButton && !_ctx.isReverseJourney)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                "data-testid": "booking-v4-goods-package-button-reset",
                class: "text-xs font-semibold text-red-lp-2400",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onResetClick && _ctx.onResetClick(...args)))
              }, _toDisplayString(_ctx.$t("bookingV4.goods.button.reset")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSavedPackageCards)
      ? (_openBlock(), _createBlock(_component_SavedPackageCards, {
          key: 1,
          "saved-packages": _ctx.savedPackages,
          "is-foreign": _ctx.isForeign,
          "customer-id": _ctx.customerId,
          "active-saved-package-id": _ctx.activeSavedPackageId,
          onSelectSavedPackage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('selectSavedPackage', $event)))
        }, null, 8, ["saved-packages", "is-foreign", "customer-id", "active-saved-package-id"]))
      : _createCommentVNode("", true),
    (_ctx.showItemDetails)
      ? (_openBlock(), _createBlock(_component_ItemDetailsV4, {
          key: 2,
          ref: "itemDetailsRef",
          isReverseJourney: _ctx.isReverseJourney,
          "model-value": _ctx.commodityCipl,
          errors: _ctx.errors,
          "is-ftz": _ctx.isFtz,
          "local-currency": _ctx.localCurrency,
          "currency-prefix": _ctx.currencyPrefix,
          "numeric-locale": _ctx.numericLocale,
          "estimated-conversion": _ctx.estimatedConversion,
          "deminimis-threshold": _ctx.deminimisThreshold,
          "deminimis-exceeded": _ctx.deminimisExceeded,
          "destination-currency-code": _ctx.destinationCurrencyCode,
          "recipient-import-doc-required": _ctx.recipientImportDocRequired,
          "self-clearance-required": _ctx.selfClearanceRequired,
          commodities: _ctx.ciplCommodities,
          configGoodsPrice: _ctx.configGoodsPrice,
          configCipl: _ctx.configCipl,
          "is-foreign": _ctx.isForeign,
          isRequired: _ctx.isItemDetailsRequired,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:commodityCipl', $event))),
          onValidationChange: _ctx.onCiplValidationChange
        }, null, 8, ["isReverseJourney", "model-value", "errors", "is-ftz", "local-currency", "currency-prefix", "numeric-locale", "estimated-conversion", "deminimis-threshold", "deminimis-exceeded", "destination-currency-code", "recipient-import-doc-required", "self-clearance-required", "commodities", "configGoodsPrice", "configCipl", "is-foreign", "isRequired", "onValidationChange"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CommoditySectionV4, {
      "model-value": _ctx.selectedCommodity,
      commodities: _ctx.commodities,
      "recommended-commodities": _ctx.recommendedCommodities,
      errors: _ctx.errors,
      "is-foreign": _ctx.isForeign,
      loading: _ctx.loading,
      "has-more": _ctx.hasMore,
      configCommodity: _ctx.configCommodity,
      "onUpdate:modelValue": _ctx.onCommodityUpdate,
      onValidationChange: _ctx.onCommodityValidationChange,
      onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('searchCommodity', $event))),
      onLoadMore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('loadMoreCommodities', $event))),
      onOpenModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCommodityModalOpen = true)),
      onCommodityError: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('commodityError', $event)))
    }, null, 8, ["model-value", "commodities", "recommended-commodities", "errors", "is-foreign", "loading", "has-more", "configCommodity", "onUpdate:modelValue", "onValidationChange"]),
    (_ctx.isCommodityModalOpen)
      ? (_openBlock(), _createBlock(_component_ModalAllCommodityV4, {
          key: 3,
          "search-results": _ctx.modalSearchResults,
          categories: _ctx.commodityCategories,
          "category-commodities": _ctx.activeCategoryCommodities,
          "selected-category-code": _ctx.activeCategoryCode,
          "recommended-commodities": _ctx.recommendedCommodities,
          "is-foreign": _ctx.isForeign,
          loading: _ctx.modalLoading,
          "loading-category": _ctx.modalLoadingCategory,
          "has-more": _ctx.modalHasMore,
          onClose: _ctx.onModalClose,
          onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('searchCommodityModal', $event))),
          onLoadMore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('loadMoreCommodityModal', $event))),
          onSelectCategory: _ctx.onSelectCategory,
          onSelect: _ctx.onModalSelect
        }, null, 8, ["search-results", "categories", "category-commodities", "selected-category-code", "recommended-commodities", "is-foreign", "loading", "loading-category", "has-more", "onClose", "onSelectCategory", "onSelect"]))
      : _createCommentVNode("", true),
    (!_ctx.isReverseJourney)
      ? (_openBlock(), _createBlock(_component_PackageWeightSectionV4, {
          key: 4,
          "model-value": _ctx.pieces,
          form: _ctx.modelValue,
          errors: _ctx.errors,
          "volume-weight-divisor": _ctx.volumeWeightDivisor,
          "hws-config": _ctx.hwsConfig,
          "max-pieces": _ctx.maxPieces,
          "single-piece-only": _ctx.singlePieceOnly,
          "disable-add-piece": _ctx.disableAddPiece,
          "numeric-locale": _ctx.numericLocale,
          "show-sub-kg-helper": !_ctx.showItemDetails,
          "use-default-dimensions": _ctx.useDefaultDimensions,
          configGrossWeight: _ctx.configGrossWeight,
          configDimension: _ctx.configDimension,
          configAdjustPieceAdd: _ctx.configAdjustPieceAdd,
          configAdjustPieceRemove: _ctx.configAdjustPieceRemove,
          isShowSectionUpload: _ctx.isShowSectionUpload,
          disabledWeightAdjustment: _ctx.disabledWeightAdjustment,
          minWeightThreshold: _ctx.minWeightThreshold,
          isMaxChWeight: _ctx.isMaxChWeight,
          preventDecreasedWeight: _ctx.preventDecreasedWeight,
          isEdit: _ctx.isEdit,
          eligibleEditSize: _ctx.eligibleEditSize,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:pieces', $event))),
          onValidationChange: _ctx.onPackageWeightValidationChange,
          onGrossWeightChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('grossWeightChange'))),
          onTariffContextChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('tariffContextChange')))
        }, null, 8, ["model-value", "form", "errors", "volume-weight-divisor", "hws-config", "max-pieces", "single-piece-only", "disable-add-piece", "numeric-locale", "show-sub-kg-helper", "use-default-dimensions", "configGrossWeight", "configDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "isShowSectionUpload", "disabledWeightAdjustment", "minWeightThreshold", "isMaxChWeight", "preventDecreasedWeight", "isEdit", "eligibleEditSize", "onValidationChange"]))
      : _createCommentVNode("", true),
    (_ctx.showSavePackageCheckbox)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_Checkbox, {
            id: "save-package-checkbox",
            class: "red-checkbox",
            modelValue: _ctx.savePackage,
            binary: true,
            disabled: false,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('update:savePackage', $event)))
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.checkbox.label")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})